import { Component, OnInit, Input, SimpleChanges, OnChanges } from '@angular/core';
import { FormGroup, FormBuilder, Validators } from '@angular/forms';
import { Title } from '@angular/platform-browser';

import { PasswordValidator } from './../../validator/password-validator';

import { MemberService } from './../../rest/api/member.service';
import { HelperService } from './../../services/helper.service';

import { environment } from '../../../environments/environment';

@Component({
  selector: 'app-reset-password',
  templateUrl: './reset-password.component.html',
  styleUrls: ['./reset-password.component.scss']
})
export class ResetPasswordComponent implements OnInit, OnChanges {
  @Input() emailData;
  resetPasswordForm: FormGroup;
  isSubmitting = false;
  isSubmitted = false;

  errors = [];
  successMsg: string;
  errorMsg: string;

  email: any;

  loader = true;

  clientId: any;
  clientSecret: any;
  constructor(
    public fb: FormBuilder,
    public memberService: MemberService,
    public helperService: HelperService,
    public title: Title
  ) {
    this.clientId = environment.clientId;
    this.clientSecret = environment.clientSecret;
  }

  ngOnInit() {
    this.resetPasswordFormInit();
  }

  ngOnChanges(changes: SimpleChanges) {
    if (changes.emailData && changes.emailData.currentValue) {
      this.resetPasswordFormInit();
    }
  }

  resetPasswordFormInit() {
    this.resetPasswordForm = this.fb.group({
      email: [{value: this.emailData, disabled: true},
        [Validators.required, Validators.email, Validators.pattern('^[a-zA-Z0-9_.+-]+@[a-zA-Z0-9-]+.[a-zA-Z0-9-.]+$')]],
      token: ['', [Validators.required, Validators.pattern(/[0-9]{6}/)] ],
      password: ['', [Validators.required, Validators.minLength(5), Validators.maxLength(20)]],
      confirm_password: ['', [Validators.required, Validators.minLength(5), Validators.maxLength(20)]]
    },
    {
      validator: [PasswordValidator.MatchPassword]
    }
    );
  }

  submit(value) {
    if (!this.resetPasswordForm.valid) {
      this.isSubmitting = true;
      return;
    }
    if (this.isSubmitted) {
      return;
    }
    this.isSubmitted = true;
    this.resetErrors();
    const data = value;
    data.email = this.emailData;
    data.client_id = this.clientId;
    data.client_secret = this.clientSecret;
    this.resetPasswordMembers(data);
  }

  resetErrors() {
    this.errorMsg = undefined;
    this.errors = [];
  }

  resetPasswordMembers(data) {
    data = this.helperService.updateJsonFormat(data);
    this.memberService.resetPassword(data).subscribe(response => {
      this.successMsg = 'Password was successfully changed. Redirecting you to login page!';
      setTimeout(() => {
        window.location.href = '/login';
      }, 3000);
    }, err => {
      this.handleErrors(err);
    });

  }

  handleErrors(err) {
    if (err.error && err.error.errors) {
      this.errors = err.error.errors;
    } else if (err.error && err.error.error) {
      this.errorMsg = err.error.error;
    } else {
      this.errorMsg = 'Unable to change password at this time.';
    }
    this.isSubmitted = false;
    this.isSubmitting = false;
    setTimeout(() => {
      this.resetErrors();
    }, 5000);
  }

}
